import { httpApi } from "./http.api";

export const getRolesData = (): Promise<any[]> =>
  httpApi.get<any[]>("hiring/job/?all=True").then((data: any) => data.data);

export const getAllCompanyGroups = (
  orderings: any = ""
): Promise<{
  count: number;
  next: string;
  previous: string | undefined;
  results: any[];
}> =>
  httpApi
    .get<{
      count: number;
      next: string;
      previous: string | undefined;
      results: any[];
    }>("company/company-groups/?ordering" + orderings)
    .then((data: any) => data.data);

export const getCompanyGroupById = (
  id: any = ""
): Promise<{
  id: number;
  companies_count: number;
  created: string;
  modified: string;
  title: string;
  companies: string[];
}> =>
  httpApi
    .get<{
      id: number;
      companies_count: number;
      created: string;
      modified: string;
      title: string;
      companies: string[];
    }>("company/company-groups/" + id + "/")
    .then((data: any) => data.data);

export const saveCompanyGroup = (
  title: string,
  companies: string[]
): Promise<any> =>
  httpApi
    .post<any>("company/company-groups/", {
      title,
      companies,
    })
    .then(({ data }) => data);

export const editCompanyGroup = (
  id: any,
  title: string,
  companies: string[]
): Promise<any> =>
  httpApi
    .patch<any>("company/company-groups/" + id + "/", {
      title,
      companies,
    })
    .then(({ data }) => data);

export const deleteCompanyGroup = (id: any): Promise<any> =>
  httpApi
    .delete<any>("company/company-groups/" + id + "/", {})
    .then(({ data }) => data);
